import { useContext } from "react";
import { LanguageContext } from "../../../store/language-context";
import MultiLanTxt from "../../UI/MultiLanTxt/MultiLanTxt";
import classes from "./LanguageTogeler.module.css";

const LanguageTogeler = () => {
  const { userLanguageChange, userLanguage } = useContext(LanguageContext);
  const options = [
    { value: "en", label: "ENGLISH" },
    { value: "pe", label: "PERSIAN" },
  ];

  return (
    <div className={classes.container}>
      {options.map((eachLan) => (
        <span
          key={eachLan.value}
          className={[classes.eachLan, userLanguage === eachLan.value ? classes.active : null].join(" ")}
          onClick={(e) => userLanguageChange(eachLan.value)}
        >
          <MultiLanTxt tid={eachLan?.label} />
        </span>
      ))}
    </div>
  );
};

export default LanguageTogeler;
